<template>
  <div class="">
    <h1 class="text-center" :id="`section_name_${sectionName}`" :class="`archive-section-${sectionName}`">
      {{ $t(`search.single.${sectionName}`) }}
    </h1>

    <div class="col-lg-12">
      <div class="row">
        <div v-for="(item,index) in section.data" class="categories-card col-6 col-md-6 p-1 mt-1"
             :class="`archive-section-${sectionName}  col-lg-${gridNumber}`"
             :key="item.id">

         <component :offerType="offerType" :offerStatus="offerStatus"
             :is="productCardName" :class="`archive-section-${sectionName}`" v-if="sectionName==='product' " :product="item" />


          <brand-card :class="`archive-section-${sectionName}`" v-if="sectionName==='brand' " :item="item"/>

          <!--          <course-card :class="`archive-section-${sectionName}`" v-if="sectionName==='course' " :item="item"/>-->

          <category-card :class="`archive-section-${sectionName}`" v-if="sectionName==='category' " :item="item"/>

          <content-card :class="`archive-section-${sectionName}`" v-if="sectionName==='content' " :item="item"/>


        </div>
      </div>
    </div>


    <m-paginate1 class="my-3" :class="`archive-section-${sectionName}`" :meta="section.meta"
                 :enable-scroll-top-on-page-change="false"
                 :on-change-page="paginationManager"/>
  </div>
</template>

<script>
import {searchTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Search'
import CategoryCard from "./CategoryCard";
import BrandCard from "./BrandCard";
import ContentCard from "./ContentCard";
import CourseCard from "./CourseCard";
import LessonCard from "./LessonCard";
import mPaginate1 from "../../../../Pagination/Paginate1";
import {Cards} from "../../../../Product/Card/Cards";
import {OfferProps} from '../../../../Product/ProductOffer/ProductOfferProps'


export default {
  name: "SearchSection",
  components: {...Cards, CategoryCard, mPaginate1, BrandCard, ContentCard, CourseCard, LessonCard},
  props: {
    sectionName: {},
    section: {},
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    ...OfferProps,

  },
  data() {
    return {
      words: '',
      searchTypes
    }
  },
  computed: {
    gridNumber() {
      // basically we create this function to make product section have 4 column
      return this.sectionName == 'product' ? 3 : 4
    }
  },
  methods: {
    paginationManager(page) {
      let words = this.$route.params.words
      document.getElementById(`section_name_${this.sectionName}`).scrollIntoView({behavior: 'smooth'});
      this.$store.dispatch('Search/search', {type: this.sectionName, words: words, page: page, stateMode: 'append'})
    },
  },
}
</script>

<style scoped>

</style>